import React from 'react';

const Chapter31CTA = () => {
  return (
    <div>
      <a
        href="/careers-employment/vocational-rehabilitation/apply-vre-form-28-1900"
        className="vads-c-action-link--green"
      >
        Apply for VR&E benefits
      </a>
    </div>
  );
};

export default Chapter31CTA;
